var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#EFF3F6"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9,
  r: 3,
  fill: "#BDCDDA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 13C8.68629 13 6 15.6863 6 19H18C18 15.6863 15.3137 13 12 13Z",
  fill: "#BDCDDA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-user.dfe19d85a60c5b5865f111b7a44a6190.svg";